import React, { useRef, useState } from 'react'
import { generateUniqueId } from '@services/utils.service'
import { useUserSettings } from '@utils/queries/user.queries';
import { setFloodModalStatus, setCurrentFlood } from '@App/components/LayerSelector/layer-selector.redux.action';

import FloodScenarioModal from '@App/components/FloodScenarioModal/FloodScenarioModal';
import { useDispatch, useSelector } from 'react-redux';
import { setShowData } from '@templates/T1/t1.redux.actions';
import { Button, Input, Loader } from '@nazka/nazka.mapframe.components';
import { useMutation } from '@tanstack/react-query';
import queryClient from '@utils/queries/QueryClient';
import { faPencil, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { toast } from 'react-toastify';

import './flood-custom-radio.styl'
import axios from 'axios';

function FloodCustomRadio(props) {
  const {
    label, name, value, checked, onChange, selectedValue,
  } = props;
  const dispatch = useDispatch()
  const idRef = useRef(generateUniqueId());

  const isFloodModalOpen = useSelector(state => state.layerSelector.isFloodModalOpen);
  const userSelectedMode = useSelector(state => state.maplibreMap.userSelectedMode);
  const { data: userSettings } = useUserSettings();
  const [isEditOn, setIsEditOn] = useState(false)
  const [newName, setNewName] = useState(null)
  const [placeholderName, setPlaceholderName] = useState(label)

  const {
    floodMeasures,
    floodYear,
  } = userSettings || {};

  const openModal = () => {
    dispatch(setShowData(false))
    dispatch(setFloodModalStatus(true))
  }

  const { mutate: removeCustomFlood } = useMutation({
    mutationFn: async (floodId) => {
      await axios.delete(`/api/upload/flood/${floodId}`);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['flood-records'] })
      dispatch(setCurrentFlood('default'))
    },
    onSuccess: () => {
      toast.success('Successfully deleted your custom flood extent')
    },
    onError: error => toast.error(error.message || 'Something went wrong deleting your flood damage'),
  });

  const { mutate: updateDamageLayerName, isPending } = useMutation({
    mutationFn: async () => {
      if (newName) {
        await axios.put(`api/upload/flood/${value}`, {
          name: newName,
        });
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['flood-records'] })
      setNewName(null);
    },
    onSuccess: () => {
      setNewName(null)
      toast.success('Successfully updated your flood extent')
    },
    onError: () => toast.error('Something went wrong updating your flood extent'),
  });

  const editHandler = (e, mode) => {
    e.preventDefault()
    if (mode === 'edit') {
      setIsEditOn(prevState => !prevState)
    }
    
    if (newName) {
      updateDamageLayerName()
    }
  }
  
  return (
    <div className="flood-custom-radio">
      <div className="flood-custom-radio__cta-wrappers">
        <div>
          <input
            id={idRef.current}
            className="radio__input"
            type="radio"
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
          />
          {isPending ? (
            <Loader
              css={{
                height: '40px',
                width: '40px',
              }}
            />
          ) : (
            <label htmlFor={idRef.current} className="radio__label">
              {isEditOn ? (
                <Input
                  onInputChange={(e) => {
                    setNewName(e.target.value)
                    setPlaceholderName(e.target.value)
                  }} 
                  rootElProps={{ placeholder: 'New damage layer name' }}
                  css={{
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    outline: 'none',
                    height: '25px',
                  }}
                  value={placeholderName}
                />
              ) : (
                <span contentEditable={isEditOn}>
                  {label.length > 25
                    ? `${label.substring(0, 20)}...`
                    : label}
                </span>
              )}
          
            </label>
          )}
        </div>
        {value !== 'default' && (
          <div className="builds-custom-radio__btn-wrapper">
            <Button 
              icon={faPencil} 
              onClick={e => editHandler(e, 'edit')}
              color="white"
              hover={false}
              className="layer-selector__delete__button"
              iconProps={{
                size: '14px',
              }}
              css={{
                color: 'grey',
                marginLeft: 0,
                padding: 0,
                '&:hover': {
                  color: 'black',
                },
                '&:disabled': {
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: 'grey',
                  '&:hover': {
                    color: 'grey',
                  },
                },
              }}
            />
            <Button 
              icon={faTrash} 
              onClick={() => removeCustomFlood(value)} 
              color="white"
              hover={false}
              className="layer-selector__delete__button"
              iconProps={{
                size: '14px',
              }}
              css={{
                color: 'grey',
                marginLeft: 0,
                padding: 0,
                '&:hover': {
                  color: 'black',
                },
                '&:disabled': {
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: 'grey',
                  '&:hover': {
                    color: 'grey',
                  },
                },
              }}
            />
          </div>
        )}
       
      </div>
      
      {value === 'default' && selectedValue === 'default' && (
        <div>
          <div className="layer-selector_flood__scenario__info__text">
            <span>
              {floodYear}
              -year flood,
              {' '}
              {' '}
            </span>
            <span>
              {floodMeasures ? (
                <span>
                  {floodMeasures === '_Measures' ? 'Anti-flood measures included' : 'Climate change included'}
                </span>
              ) : (
                <span>No scenario</span>
              )}
            </span>
          </div>

          <Button
            onClick={openModal}
            className="layer-selector__change__scenarios"
            color="#0367A5"
            hoverColor="#0367A5"
            layout="outlined"
            css={{
              borderRadius: '3px',
              padding: '3px',
              fontSize: '12px',
              marginBottom: '6px',
            }}
          >
            Change flood scenario
          </Button>
          {isFloodModalOpen && (
          <FloodScenarioModal
            closeModal={() => dispatch(setFloodModalStatus(false))}
            floodYear={floodYear}
            floodMeasures={floodMeasures}
            userSelectedMode={userSelectedMode}
          />
          )}
        </div>
      )}
    </div>
  );
}

export default FloodCustomRadio